package com.gsb.vyapar.bhagya.presentation.navigation.view

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Surface
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.zIndex
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularBB
import com.gsb.vyapar.bhagya.presentation.common.toolbar.Toolbar
import com.gsb.vyapar.bhagya.theme.black
import com.gsb.vyapar.bhagya.util.BuildConfig
import com.gsb.vyapar.bhagya.util.PlatformType

@Composable
fun FullScreenBusinessMapView(
    uiState: UiState,
    onTriggerEvent: (UiEvents) -> Unit,
) {
    val businessLocations = uiState.businessLocationPins()
    val isSupportedPlatform =
        BuildConfig.platform() == PlatformType.ANDROID || BuildConfig.platform() == PlatformType.IOS || BuildConfig.platform() == PlatformType.JS || BuildConfig.platform() == PlatformType.DESKTOP

    val toolbarHeight = 50.dp

    Surface(
        modifier = Modifier.fillMaxSize(),
        color = MaterialTheme.colors.background
    ) {
        Box(modifier = Modifier.fillMaxSize()) {
            when {
                !isSupportedPlatform -> {
                    Box(
                        modifier = Modifier
                            .fillMaxSize()
                            .padding(top = toolbarHeight),
                        contentAlignment = Alignment.Center
                    ) {
                        Text14RegularBB(
                            text = "Full map view is available on mobile devices only.",
                            color = black
                        )
                    }
                }

                businessLocations.isEmpty() -> {
                    Box(
                        modifier = Modifier
                            .fillMaxSize()
                            .padding(top = toolbarHeight),
                        contentAlignment = Alignment.Center
                    ) {
                        Text14RegularBB(
                            text = "No business locations available yet.",
                            color = black
                        )
                    }
                }

                else -> {
                    PlatformBusinessMap(
                        modifier = Modifier
                            .fillMaxSize()
                            .padding(top = toolbarHeight),
                        businessLocations = businessLocations,
                        uiState = uiState,
                        onTriggerEvent = onTriggerEvent,
                        onInteractionChanged = {},
                        retainState = true
                    )
                }
            }

            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .align(Alignment.TopCenter)
                    .zIndex(1f)
            ) {
                Toolbar(title = "Business Map")
            }
        }
    }
}
